
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[...categories]",
      function () {
        return require("private-next-pages/c/[...categories].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[...categories]"])
      });
    }
  